<template>
  <div class="mobile-page">
    <van-nav-bar
      v-if="showNav"
      :title="title"
      class="custom-nav-bar"
      :border="false"
    >
      <template #left>
        <van-icon
          v-if="showBack"
          name="arrow-left"
          size="22"
          class="nav-left-icon"
          @click.stop="handleBack"
        />
        <van-icon
          v-if="showDrawerToggle"
          name="wap-nav"
          size="22"
          class="nav-drawer-icon"
          @click.stop="openDrawer"
        />
      </template>
    </van-nav-bar>
    <div ref="body" class="mobile-page-body">
      <div :class="['mobile-page-pad-wrap', { 'is-pad': isPad }]">
        <component v-if="resolvedView" :is="resolvedView" />
      </div>
    </div>
  </div>
</template>

<script>
import { isPadDevice } from '@/utils/device'

export default {
  name: 'MobilePage',
  data() {
    return {
      resolvedView: null,
      childHasHeader: false,
      headerObserver: null
    }
  },
  computed: {
    isPad() {
      return isPadDevice()
    },
    leafMeta() {
      const matched = this.$route && this.$route.matched
      const last = matched && matched.length ? matched[matched.length - 1] : null
      return (last && last.meta) || (this.$route && this.$route.meta) || {}
    },
    title() {
      return (this.leafMeta && this.leafMeta.title) || ''
    },
    showNav() {
      return !!(this.leafMeta && this.leafMeta.mobileNav) && !this.childHasHeader
    },
    showDrawerToggle() {
      return !!(this.leafMeta && this.leafMeta.mobileDrawer)
    },
    canBack() {
      return this.$route && this.$route.path !== '/'
    },
    inMemberCenter() {
      const p = this.$route && this.$route.path
      return typeof p === 'string' && p.indexOf('/member-center') === 0
    },
    showBack() {
      if (!this.canBack) return false
      if (this.showDrawerToggle && this.inMemberCenter) return false
      return true
    }
  },
  created() {
    this.resolveView()
  },
  watch: {
    $route() {
      this.resolveView()
    }
  },
  mounted() {
    this.detectChildHeader()
  },
  beforeDestroy() {
    if (this.headerObserver) {
      this.headerObserver.disconnect()
      this.headerObserver = null
    }
  },
  methods: {
    resetHeaderDetection() {
      this.childHasHeader = false
      if (this.headerObserver) {
        this.headerObserver.disconnect()
        this.headerObserver = null
      }
    },
    detectChildHeader() {
      if (typeof MutationObserver === 'undefined') return
      const cleanup = () => {
        if (this.headerObserver) {
          this.headerObserver.disconnect()
          this.headerObserver = null
        }
      }
      const check = () => {
        const body = this.$refs.body
        if (!body) return false
        if (body.querySelector('.van-nav-bar, .mobile-header, .auth-header-nav')) {
          this.childHasHeader = true
          cleanup()
          return true
        }
        return false
      }
      this.$nextTick(() => {
        if (check()) return
        this.resetHeaderDetection()
        this.headerObserver = new MutationObserver(() => {
          check()
        })
        this.headerObserver.observe(this.$refs.body, { childList: true, subtree: true })
        // Fallback for slow async renders
        setTimeout(check, 300)
        setTimeout(check, 800)
      })
    },
    async resolveView() {
      this.resetHeaderDetection()
      const meta = this.leafMeta || {}
      const viewOrLoader = meta.mobileView || meta.pcView
      if (!viewOrLoader) {
        this.resolvedView = null
        return
      }
      if (typeof viewOrLoader === 'function') {
        const modOrComp = await viewOrLoader()
        this.resolvedView = (modOrComp && (modOrComp.default || modOrComp)) || null
      } else {
        this.resolvedView = viewOrLoader
      }
      this.detectChildHeader()
    },
    openDrawer() {
      this.$root.$emit('mobile:open-drawer')
    },
    handleBack() {
      this.$router.back()
    }
  }
}</script>

<style scoped>
.mobile-page {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
}

.mobile-page-body {
  flex: 1;
  overflow: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: env(safe-area-inset-bottom);
}

.nav-left-icon {
  padding: 0 6px;
  font-size: 22px;
}

.nav-drawer-icon {
  margin-left: 4px;
  padding: 0 6px;
  font-size: 22px;
}

::v-deep .van-nav-bar {
  height: 50px;
}

::v-deep .van-nav-bar__title {
  font-size: 19px;
  font-weight: 600;
  color: #333;
}

::v-deep .van-nav-bar__arrow {
  font-size: 22px;
  color: #333;
}

::v-deep .van-nav-bar__left,
::v-deep .van-nav-bar__right {
  padding: 0 12px;
}

::v-deep .van-nav-bar__right .van-icon {
  font-size: 22px;
}
</style>
